import axios from "axios";
import { store } from "../redux/store";
import { selectToken } from "../redux/slices/userSlice";
import { API_CONSTANTS } from "../config/apiConfig";
import { selectUser } from "../redux/slices/userSlice";
const updateVersionFromStore = () => {
  try {
    const state = store.getState();
    const userdata = selectUser(store.getState()); // Ya jo bhi selector hai
    commonHeaders.version = userdata?.EnablePosBillingForPincode ? "1.1.25" : "1.1.22";
  } catch (error) {
    console.log('Error updating version, using default');
  }
};
const AxiosAPI = axios.create({
  baseURL: API_CONSTANTS.BASE_URL,
  headers: {
    "Content-Type": "application/json",
    //  version: "1.1.22",
  },
});

AxiosAPI.interceptors.request.use((config) => {
  const token = selectToken(store.getState());
  // console.log(token);

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const state = store.getState();
  // console.log("userdata",userdata)

  // config.headers.version = userdata?.EnablePosBillingForPincode
  //   ? "1.1.28"
  //   : "1.1.22";


  return config;
});

export default AxiosAPI;
